import { render, staticRenderFns } from "./rap-image.vue?vue&type=template&id=1a5f0dc8&scoped=true&"
import script from "./rap-image.vue?vue&type=script&lang=js&"
export * from "./rap-image.vue?vue&type=script&lang=js&"
import style0 from "./rap-image.vue?vue&type=style&index=0&id=1a5f0dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f0dc8",
  null
  
)

export default component.exports